import { UserInitialStateType } from "DataTypes/Redux";
import { store } from "Redux/Store";
import dayjs, { Dayjs } from "dayjs";
import utc from "dayjs/plugin/utc";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(utc);
dayjs.extend(customParseFormat);

const utcFormat = "YYYY-MM-DDTHH:mm";
const utcDateFormat = "YYYY-MM-DD";
// const utcFormat1 = "YYYY-MM-DDTHH:mm:ss";

const ValidDate: (date: any) => string = (date) => {
  if (date && dayjs(date).isValid() && typeof date == "string") {
    const dateArr = date?.split(".");
    if (dateArr.length > 0) return dateArr[0];
    else return date;
  } else return "";
};
const CurrentTime: () => string = () => dayjs().format("HH:mm");
const CurrentDate: () => string = () => {
  const { dateFormat } = store.getState().user.myInfo;
  return dayjs().format(dateFormat);
};
const CurrentDateTime: () => string = () => {
  const { dateTimeFormat } = store.getState().user.myInfo;
  return dayjs().format(dateTimeFormat);
};
const TomorrowLocalDateTime: () => string = () => {
  const { dateTimeFormat } = store.getState().user.myInfo;
  return dayjs().add(+1, "day").format(dateTimeFormat);
};
const CurrentDateTimeSec: () => string = () => {
  const { dateTimeSecFormat } = store.getState().user.myInfo;
  return dayjs().format(dateTimeSecFormat);
};
const CurrentMonth: () => string = () => dayjs().format("MM");
const CurrentMonthName: () => string = () => dayjs().format("MMMM");
const CurrentYear: () => string = () => dayjs().format("YYYY");
const MonthNameFromDate: (data: any) => string = (data) => {
  const valid = ValidDate(data);
  if (valid) return dayjs(valid).format("MMMM")
  else return ""
};
const YearFromDate: (data: any) => string = (data) => {
  const valid = ValidDate(data);
  if (valid) return dayjs(valid).format("YYYY")
  else return ""
};
const CurrentMonthStartDate: () => string = () => {
  const { dateFormat } = store.getState().user.myInfo;
  return dayjs().startOf("month").format(dateFormat);
};
const NextMonthEndDate: () => string = () => {
  const { dateFormat } = store.getState().user.myInfo;
  return dayjs().add(1, "month").endOf("month").format(dateFormat);
};
const NextMonthStartDateTime: () => string = () => {
  const { dateTimeFormat } = store.getState().user.myInfo;
  return dayjs().add(1, "month").startOf("month").format(dateTimeFormat);
};
const NextYearDateTimeFromCurrentDate: () => string = () => {
  const { dateTimeFormat } = store.getState().user.myInfo;
  return dayjs().add(1, "year").format(dateTimeFormat);
};
const TomorrowDateTime: () => string = () => {
  return dayjs().add(+1, "day").format(utcFormat);
};
const PreviousMonthDateTime: () => string = () => {
  const { dateTimeFormat } = store.getState().user.myInfo;
  return dayjs().add(-31, "day").format(dateTimeFormat);
};
const MonthNameToNumber: (month: string) => number = (month) => {
  return dayjs(month, "MMMM").month() + 1
};
const YearToNumber: (year: string) => number = (year) => {
  return dayjs(year).year()
};

const ToLocalDate: (data: any) => string = (data) => {
  const { dateFormat } = store.getState().user.myInfo;
  const valid = ValidDate(data);
  if (valid) return dayjs(valid).format(dateFormat);
  else return "";
};
const ToLocalPDFDate: (data: any) => string = (data) => {
  const valid = ValidDate(data);
  if (valid) return dayjs(valid).format("MMDDYYYY");
  else return "";
};
const ToLocalDateTime: (data: any) => string = (data) => {
  const { dateTimeFormat } = store.getState().user.myInfo;
  const valid = ValidDate(data);
  if (valid) return dayjs(valid).format(dateTimeFormat);
  else return "";
};
const ToLocalDateTimeSec: (data: any) => string = (data) => {
  const { dateTimeSecFormat } = store.getState().user.myInfo;
  const valid = ValidDate(data);
  if (valid) return dayjs(data).format(dateTimeSecFormat);
  else return "";
};
const UTCToLocalDateTime: (
  data: any,
  localTZ?: string
) => string = (data, localTZ) => {
  const { dateTimeFormat, timezone } = store.getState().user.myInfo;
  const newDate = ValidDate(data);
  const utcDate = dayjs.utc(newDate);
  const timezone1 = localTZ || timezone;
  if (newDate && utcDate.isUTC()) {
    if (timezone1) {
      const newTZ = SelectTimeZone(timezone1);
      return utcDate.tz(newTZ).format(dateTimeFormat);
    } else return utcDate.local().format(dateTimeFormat);
  } else return "";
};
const UTCToLocalDateTimeGraph: (data: any) => string = (data) => {
  const { timezone } = store.getState().user.myInfo;
  const newDate = ValidDate(data);
  const utcDate = dayjs.utc(newDate);
  if (newDate && dayjs.utc(newDate).isUTC()) {
    if (timezone) {
      const newTZ = SelectTimeZone(timezone);
      return utcDate.tz(newTZ).format("YYYY-MM-DDTHH:mm:ss");
    } else return utcDate.local().format("YYYY-MM-DDTHH:mm:ss");
  } else return "";
};
const UTCToLocalDateTimeSec: (
  data: any,
  localTZ?: string
) => string = (data, localTZ) => {
  const { dateTimeSecFormat, timezone } = store.getState().user.myInfo;
  const newDate = ValidDate(data);
  const utcDate = dayjs.utc(newDate);
  const timezone1 = localTZ || timezone;
  if (newDate && utcDate.isUTC()) {
    if (timezone1) {
      const newTZ = SelectTimeZone(timezone);
      return utcDate.tz(newTZ).format(dateTimeSecFormat);
    } else return utcDate.local().format(dateTimeSecFormat);
  } else return "";
};
const MonthName: (month: number | null) => string = (month) => {
  if (month && month > 0)
    return dayjs()
      .month(month - 1)
      .format("MMMM");
  else return "";
};
const ToUTCDate: (data: any) => string = (data) => {
  const valid = ValidDate(data);
  if (valid) return dayjs(valid).format(utcDateFormat);
  else return "";
};
const GetMonth: (data: any) => string = (data) => {
  const valid = ValidDate(data);
  if (valid) return dayjs(valid).format("MM") || "";
  else return "";
};
const GetYear: (data: any) => string = (data) => {
  const valid = ValidDate(data);
  if (valid) return dayjs(valid).format("YYYY") || "";
  else return "";
};

const GetTimeStamp: (date: any) => number = (date) => {
  return dayjs(date).valueOf();
};

const AddSubDay: (date: string, days: number) => string = (date, days) => {
  const valid = ValidDate(date);
  if (valid) return dayjs(date).add(days, "d").format(utcDateFormat);
  else return "";
};
const AddSubMin: (date: string, min: number) => string = (date, min) => {
  const valid = ValidDate(date);
  if (valid) return dayjs(valid).add(min, "m").format(utcFormat);
  else return "";
};
const CurrentDateSubtraction: (
  date: string,
  value: number,
  unit: dayjs.ManipulateType
) => string = (date, value, unit) => {
  const valid = ValidDate(date);
  const { dateFormat } = store.getState().user.myInfo;
  if (valid) return dayjs(valid).subtract(value, unit).format(dateFormat);
  else return "";
};
const ToDbUtcFormat: (date: string) => string = (date) => {
  const valid = ValidDate(date);
  if (valid) return valid + ":00.000Z";
  else return "";
};

const AddHoursUTCToLocalDateTime: (number: number, date: any) => string = (
  number,
  date
) => {
  const { dateTimeFormat } = store.getState().user.myInfo;
  return dayjs(date).add(number, "hour").format(dateTimeFormat);
};

const AgeCalculator = (data: string): string => {
  // const currentDate = CurrentDate();
  // const currentYear = parseInt(dayjs(currentDate).format("YYYY"));
  // const dobYear = parseInt(dayjs(data).format("YYYY"));
  // return `${currentYear - dobYear}Y`;
  return dayjs().diff(dayjs(data), "year").toString();
};

const CalculateDuration: (start: string, end: string) => number = (
  start,
  end
) => {
  if (ValidDate(start) && ValidDate(end)) {
    const startDate = dayjs(start);
    const endDate = dayjs(end);
    const diff = endDate.diff(startDate, "minutes");
    return diff ? diff : 0;
  } else return 0;
};

const CalculateDurationInDays: (start: string, end: string) => number = (
  start,
  end
) => {
  if (ValidDate(start) && ValidDate(end)) {
    const startDate = dayjs(start);
    const endDate = dayjs(end);
    const diff = endDate.diff(startDate, "day");
    return diff ? diff : 0;
  } else return 0;
};

const TimeZoneRegionSwitch: (timezone: string) => {
  date: string;
  datetime: string;
  datetimesec: string;
  chartDateTimeSec: string;
} = (timezone) => {
  switch (timezone) {
    case "EST":
      return {
        date: "MM/DD/YYYY",
        datetime: "MM/DD/YYYY hh:mm A",
        datetimesec: "MM/DD/YYYY hh:mm:ss A",
        chartDateTimeSec: "MM/dd/yyyy hh:mm:ss a",
      };
    case "CST":
      return {
        date: "MM/DD/YYYY",
        datetime: "MM/DD/YYYY hh:mm A",
        datetimesec: "MM/DD/YYYY hh:mm:ss A",
        chartDateTimeSec: "MM/dd/yyyy hh:mm:ss a",
      };
    case "MST":
      return {
        date: "MM/DD/YYYY",
        datetime: "MM/DD/YYYY hh:mm A",
        datetimesec: "MM/DD/YYYY hh:mm:ss A",
        chartDateTimeSec: "MM/dd/yyyy hh:mm:ss a",
      };
    case "PST":
      return {
        date: "MM/DD/YYYY",
        datetime: "MM/DD/YYYY hh:mm A",
        datetimesec: "MM/DD/YYYY hh:mm:ss A",
        chartDateTimeSec: "MM/dd/yyyy hh:mm:ss a",
      };
    default:
      return {
        date: "MM/DD/YYYY",
        datetime: "MM/DD/YYYY hh:mm A",
        datetimesec: "MM/DD/YYYY hh:mm:ss A",
        chartDateTimeSec: "MM/dd/yyyy hh:mm:ss a",
      };
  }
};

const SelectTimeZone: (tz: string) => string = (tz) => {
  switch (tz) {
    case "EST":
      return "America/New_York"
    case "CST":
      return "America/Chicago"
    case "MST":
      return "America/Denver"
    case "PST":
      return "America/Los_Angeles"
    default:
      return "Asia/Kolkata"
  }
};

const CurrentDateTimeInPatOrgLocTZ: (
  orgTZ: string
) => dayjs.Dayjs = (orgTZ) => {
  const newTZ = SelectTimeZone(orgTZ);
  return dayjs().tz(newTZ);
};

const ConvertDateTimeInPatOrgLocTZ: (
  orgTZ: string, dateTime: string
) => dayjs.Dayjs = (orgTZ, dateTime) => {
  const newTZ = SelectTimeZone(orgTZ);
  return dayjs(dateTime).tz(newTZ);
};

const CalculateTimeDiff: (diffMs: number) => string = (diffMs) => {
  // convert diff to a duration (hours/minutes/seconds)
  const diff = dayjs.duration(diffMs);

  // format hours part (if any)
  const h = diff.hours() > 0 ? `${diff.hours()}h ` : "";

  // format minutes part (if any)
  const m = diff.minutes() > 0 ? `${diff.minutes()}m ` : "";

  // always show seconds
  const s = `${diff.seconds()}s`;
  return `${h}${m}${s}`
};

const OrgMonthStartDateTime: (
  orgTZ: string, userTZ: string
) => string = (orgTZ, userTZ) => {
  const { dateTimeFormat } = store.getState().user.myInfo;
  const fullOrgTZ = SelectTimeZone(orgTZ)
  const fullUserTZ = SelectTimeZone(userTZ)

  // 1. Get month start in FROM timezone
  const monthStartInFromTZ = dayjs().tz(fullOrgTZ).startOf("month");

  // 2. Convert TO another timezone
  const converted = monthStartInFromTZ.tz(fullUserTZ);

  return converted.format(dateTimeFormat);
};

const OrgMonthEndDateTime: (
  fromTZ: string, toTZ: string
) => string = (fromTZ, toTZ) => {
  const { dateTimeFormat } = store.getState().user.myInfo;
  const fullFromTZ = SelectTimeZone(fromTZ)
  const fullToTZ = SelectTimeZone(toTZ)

  // 1. Get month start in FROM timezone
  const monthStartInFromTZ = dayjs().tz(fullFromTZ).endOf("month");

  // 2. Convert TO another timezone
  const converted = monthStartInFromTZ.tz(fullToTZ);

  return converted.format(dateTimeFormat);
};

const CheckTodayIsLastDayOfMonth: () => boolean = () => {
  return dayjs().isSame(dayjs().endOf("month"), "day");
};

const LocalTZToUTCDateTime: (
  datetime: string, localTZ?: string
) => string = (datetime, localTZ) => {
  const { myInfo } = store.getState().user as UserInitialStateType;
  const userTZ = myInfo.timezone;
  const fullLocalTZ = SelectTimeZone(localTZ || userTZ);

  // Step 1: Attach timezone WITHOUT shifting (keepLocalTime = true)
  const zoned = dayjs(datetime).tz(fullLocalTZ, true);

  // Step 2: Convert to UTC
  const utcTime = zoned.utc();

  // Step 3: Format in required UTC shape
  const finalUtc = utcTime.format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");

  return finalUtc;
};

const CurrentToUTCDateTime: (localTZ?: string) => string = (localTZ) => {
  const { dateTimeFormat } = store.getState().user.myInfo;
  const currentDateTime = dayjs().format(dateTimeFormat);
  return LocalTZToUTCDateTime(currentDateTime, localTZ)
}

const CurrentToUTCDateTimeSec: (localTZ?: string) => string = (localTZ) => {
  const { dateTimeSecFormat } = store.getState().user.myInfo;
  const currentDateTime = dayjs().format(dateTimeSecFormat);
  return LocalTZToUTCDateTime(currentDateTime, localTZ)
}

const UTCToLocalTZDateTime: (
  datetime: string, localTZ: string
) => string = (utcDateTime, localTZ) => {
  const { dateTimeFormat } = store.getState().user.myInfo;
  const fullLocalTZ = SelectTimeZone(localTZ);

  // Step 1 — Attach UTC WITHOUT parsing/shifting
  const asUTC = dayjs(utcDateTime).tz("UTC", true);

  // Step 2: Convert to target timezone
  const converted = asUTC.tz(fullLocalTZ);

  const finalLocal = converted.format(dateTimeFormat);

  return finalLocal;
};

const FormatToDayJS: (
  datetime: any, localTZ: string
) => Dayjs = (datetime, localTZ) => {
  const validDateTime = ValidDate(datetime);
  const fullLocalTZ = SelectTimeZone(localTZ);
  return dayjs(validDateTime).tz(fullLocalTZ, true);
};

const FormatIntoDateTime: (datetime: any) => string = (datetime) => {
  const { dateTimeFormat } = store.getState().user.myInfo;
  return dayjs(datetime).format(dateTimeFormat);
};

const ConvertToDayjs: (date: string) => dayjs.Dayjs = (date) => {
  const validDate = ValidDate(date);
  return dayjs(validDate)
};

export default {
  CurrentDate,
  CurrentDateTime,
  TomorrowLocalDateTime,
  CurrentDateTimeSec,
  CurrentMonth,
  CurrentMonthStartDate,
  NextMonthStartDateTime,
  NextMonthEndDate,
  NextYearDateTimeFromCurrentDate,
  CurrentMonthName,
  CurrentYear,
  MonthNameFromDate,
  YearFromDate,
  // CurrentUTCDateTime,
  // CurrentUTCDateTimeSec,
  TomorrowDateTime,
  PreviousMonthDateTime,
  MonthNameToNumber,
  YearToNumber,
  CurrentTime,
  ValidDate,
  ToUTCDate,
  // ToUTCDateTime,
  UTCToLocalDateTime,
  UTCToLocalDateTimeGraph,
  UTCToLocalDateTimeSec,
  GetMonth,
  GetYear,
  GetTimeStamp,
  AgeCalculator,
  CurrentDateSubtraction,

  ToDbUtcFormat,

  ToLocalDate,
  ToLocalDateTime,
  ToLocalDateTimeSec,
  ToLocalPDFDate,
  CalculateDuration,
  CalculateDurationInDays,
  AddHoursUTCToLocalDateTime,
  TimeZoneRegionSwitch,
  MonthName,

  AddSubDay,
  AddSubMin,

  CurrentDateTimeInPatOrgLocTZ,
  ConvertDateTimeInPatOrgLocTZ,
  CalculateTimeDiff,
  OrgMonthStartDateTime,
  CheckTodayIsLastDayOfMonth,
  OrgMonthEndDateTime,
  LocalTZToUTCDateTime,
  CurrentToUTCDateTime,
  CurrentToUTCDateTimeSec,
  UTCToLocalTZDateTime,
  FormatIntoDateTime,
  FormatToDayJS,
  ConvertToDayjs
};
